<template>
  <el-popover :width="300" placement="bottom" trigger="click" v-model="showTreePopever">
    <el-tree class="tree-w-stroke obj-tree" ref="tree" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false"
    highlight-current @node-click="clickNode" style="max-height:500px;overflow:auto;margin:-12px;padding:12px">
      <span class="el-tree-node__label" slot-scope="{ node, data }">
        <span>
          <span>{{ data.label }}</span>
        </span>
      </span>
    </el-tree>
    <el-input :class="$style.pointer" style="width:300px" slot="reference" v-model="selectedManagegroupName" placeholder="관리그룹을 선택해주십시오." readonly />
  </el-popover>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { defaultProps, rootNode } from '@/constants/tree';
import msgUtil from '@/utils/message';
import LogicalGroupAPI from '@/api/settings/common/logical-group';

export default {
  name: 'WTreeSelectComponent',
  components: {
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultProps,
      isLoaded: false,
      treeData: null,
      showTreePopever: false,
      eventHistList: [],
      tableData: [],
      selectedManagegroupData: null,
      selectedManagegroupName: null,
    };
  },
  watch: {
    active: {
      handler(flag) {
        if (flag) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    isEmpty,
    initData() {
      this.selectedManagegroupData = null;
      this.selectedManagegroupName = null;
      // this.$emit('reset');
    },
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoaded = false;
      LogicalGroupAPI.getLogicalGroupTree().then((response) => {
        if (response.data.success) {
          this.treeData = response.data.data;
          this.$nextTick(() => {
            if (isNil(this.selectedManagegroupData)) {
              const node = this.$refs.tree.getNode(rootNode.treeKey);
              this.$refs.tree.setCurrentKey(rootNode.treeKey);
              this.clickNode(response.data.data[0]);
              node.expanded = true;
            }
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 그룹', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '관리 그룹', false));
      }).finally(() => {
        this.isLoaded = true;
      });
    },
    clickNode(data) {
      this.selectedManagegroupData = data;
      this.selectedManagegroupName = data.label;
      this.showTreePopever = false;
      this.$emit('select', this.selectedManagegroupData);
    },
  },
};
</script>

<style module>
.pointer input {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/table/LogicalObjTable/components/TreeSelectComponent.vue